module.exports = __webpack_public_path__ + "assets/img/title-41a9984f.png";